import React from 'react';
const modules = [{
  title: 'MÓDULOS 1–5 — LA RAÍZ DEL PROBLEMA',
  description: 'Para entender qué pasa realmente en tu sistema nervioso cuando no podés dormir.',
  bullets: ['La neurociencia de la rumiación nocturna', 'Por qué respirá profundo no alcanza', 'El rol del cortisol y la amígdala', 'Test de rumiación personalizado', 'Tu perfil de ansiedad nocturna']
}, {
  title: 'MÓDULOS 6–10 — EL MÉTODO NEURO-DUMP',
  description: 'El sistema de 3 pasos para vaciar, clasificar y cerrar tu mente en 15 minutos.',
  bullets: ['Paso 1: Vaciado sin filtro (7 min)', 'Paso 2: Clasificación de 4 categorías', 'Paso 3: Cierre intencional', 'El cuaderno como herramienta neurológica', 'Tu primera noche con el método']
}, {
  title: 'MÓDULOS 11–16 — HIGIENE MENTAL NOCTURNA',
  description: 'Los 4 micro-hábitos para rediseñar completamente tu noche.',
  bullets: ['La señal de inicio del ritual', 'Anclas sensoriales para el descanso', 'El cierre de oficina mental', 'La imagen de ancla personal', 'Sin pantallas: alternativas reales', 'El entorno que favorece el sueño']
}, {
  title: 'MÓDULOS 17–22 — CASOS ESPECIALES',
  description: 'Para cuando la ansiedad tiene nombre propio.',
  bullets: ['Ansiedad y ciclo hormonal', 'Ansiedad masculina silenciosa', 'Rumiación de duelo y pérdida', 'Ansiedad laboral nocturna', 'Tu tipo específico de rumiación']
}, {
  title: 'MÓDULOS 23–30 — SISTEMA COMPLETO',
  description: 'De las técnicas al hábito consolidado.',
  bullets: ['Plan de 7 días de implementación', 'Qué hacer cuando la ansiedad vuelve', 'Sin culpa: el reset del sistema', 'FAQ: las 20 dudas más frecuentes', 'Tu ritual definitivo personalizado']
}];
export function ProductPresentation() {
  return <section className="bg-sage py-12 md:py-24 px-4 text-cream-white" data-id="element-378">
      <div className="max-w-6xl mx-auto text-center" data-id="element-379">
        <div className="inline-block bg-gold text-sage-dark font-sans font-bold py-2 px-6 rounded-full text-sm mb-8 uppercase" data-id="element-380">
          💛 MENTE EN SILENCIO™ COLECCIÓN COMPLETA
        </div>

        <h2 className="font-display font-bold text-cream-white text-3xl md:text-5xl mb-12 leading-tight" data-id="element-381">
          Manual completo + 3 Bonos
          <br data-id="element-382" />
          200+ páginas
          <br data-id="element-383" />
          Todo lo que necesitás para entender,
          <br data-id="element-384" />
          regular y transformar tu descanso.
        </h2>

        <div className="max-w-4xl mx-auto mb-16 relative" data-id="element-385">
          <img src="https://cdn.magicpatterns.com/uploads/4SyLzJSDfRsRZbVMjDpizZ/mente_en_silencio_mockup2_1280.webp" alt="Full Collection Mockup" className="w-full h-auto drop-shadow-2xl rounded-lg" style={{
          maskImage: 'radial-gradient(circle, black 80%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(circle, black 80%, transparent 100%)'
        }} data-id="element-386" />
          <div className="absolute inset-0 bg-gold/5 blur-3xl -z-10 rounded-full scale-90" data-id="element-387"></div>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-16 mb-20 text-cream-white/85 font-sans" data-id="element-388">
          <p data-id="element-389">"4 módulos y bonos digitales"</p>
          <p data-id="element-390">
            "Para entender, regular y transformar tu relación con el sueño y la
            ansiedad."
          </p>
          <p data-id="element-391">
            "Basado en neurociencia aplicada. 100% adaptado a la realidad
            argentina."
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 text-left" data-id="element-392">
          {modules.map((mod, i) => <div key={i} className="bg-white/10 border border-gold/30 p-8 rounded-xl" data-id="element-393">
              <span className="text-2xl mb-4 block" data-id="element-394">🌙</span>
              <h3 className="font-sans font-bold text-gold mb-4 text-sm tracking-wide" data-id="element-395">
                {mod.title}
              </h3>
              <p className="text-cream-white mb-6 text-sm leading-relaxed" data-id="element-396">
                {mod.description}
              </p>
              <ul className="space-y-3" data-id="element-397">
                {mod.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-3 text-xs text-cream-white/90" data-id="element-398">
                    <span className="w-1.5 h-1.5 bg-sage-light/30 rounded-full mt-1 shrink-0" data-id="element-399"></span>
                    {bullet}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}